<template>
  <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
    <b-row>
      <b-col cols="" class="">
        <b-row>
          <b-col cols="">
            <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
              <h2 class="text-left mb-0">{{ $t('teamPage.title') }}</h2>
              <div class="d-flex d-sm-none justify-content-between justify-content-sm-center flex-wrap"
                >
                 <b-button @click="allowAddTeamMember = true" v-if="allowAddDriver"
                  class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                  variant="primary">
                  <b-icon icon="plus" aria-hidden="true"></b-icon>
                  <p class="mb-0 ml-2 text-white">{{ $t('teamPage.addDriver') }}</p>
                </b-button>               
                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2"
                  v-if="allowImportDrivers || allowExportDrivers || (allowUpdateDrivers && selectedRows.length)">
                  <template slot="button-content">
                    <b-icon class="dots" icon="three-dots"></b-icon>
                  </template>
                  <b-dropdown-item-button @click="downloadExcel" v-if="allowExportDrivers"
                    :class="allowImportDrivers || allowUpdateDrivers && selectedRows.length ? 'mb-2' : ''">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.exportCsv') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="allowImportDrivers"
                    :class="allowUpdateDrivers && selectedRows.length ? 'mb-2' : ''"
                    @click="$bvModal.show('modal-bulk-upload')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.importCsv') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="$bvModal.show('modal-set-password')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.setPassword') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2" v-if="allowUpdateDrivers && selectedRows.length"
                    @click="$bvModal.show('modal-bulk-division-update')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.setDivision') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2" v-if="(allowUpdateDrivers && selectedRows.length)"
                    @click="$bvModal.show('modal-add-bulk-tags')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.addTags') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="lockPopupTitle = $t('teamPage.lockVehicleTitle'); $bvModal.show('modal-lock-trailer-vehicle')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.setLockVehicle') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="lockPopupTitle = $t('teamPage.lockTrailerTitle'); $bvModal.show('modal-lock-trailer-vehicle')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.setLockTrailer') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="$bvModal.show('send-invite-modal')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.sendInvite') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="$bvModal.show('send-notification-modal')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.sendNotification') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="allowUpdateDrivers && selectedRows.length"
                    @click="showDeactivateModal = true">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ teamMemberType === 'True' ? $t('teamPage.deactivate') : $t('teamPage.activate') }}</p>
                  </b-dropdown-item-button>

                </b-dropdown>
              </div>
              <div class="d-none d-sm-flex justify-content-between justify-content-sm-center flex-wrap"
                >
                <b-button @click="allowAddTeamMember = true" v-if="allowAddDriver"
                  class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                  variant="primary">
                  <b-icon icon="plus" aria-hidden="true"></b-icon>
                  <p class="mb-0 ml-2 text-white">{{ $t('teamPage.addDriver') }}</p>
                </b-button>       

                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2"
                  v-if="allowImportDrivers || allowExportDrivers || (allowUpdateDrivers && selectedRows.length)">
                  <template slot="button-content">
                    <b-icon class="dots" icon="three-dots"></b-icon>
                  </template>
                  <b-dropdown-item-button @click="downloadExcel" v-if="allowExportDrivers"
                    :class="allowImportDrivers || allowUpdateDrivers && selectedRows.length ? 'mb-2' : ''">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.exportCsv') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="allowImportDrivers"
                    :class="allowUpdateDrivers && selectedRows.length ? 'mb-2' : ''"
                    @click="$bvModal.show('modal-bulk-upload')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.importCsv') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="$bvModal.show('modal-set-password')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.setPassword') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2" v-if="allowUpdateDrivers && selectedRows.length"
                    @click="$bvModal.show('modal-bulk-division-update')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.setDivision') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2" v-if="(allowUpdateDrivers && selectedRows.length)"
                    @click="$bvModal.show('modal-add-bulk-tags')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.addTags') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="lockPopupTitle = $t('teamPage.lockVehicleTitle'); $bvModal.show('modal-lock-trailer-vehicle')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.setLockVehicle') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="lockPopupTitle = $t('teamPage.lockTrailerTitle'); $bvModal.show('modal-lock-trailer-vehicle')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.setLockTrailer') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="$bvModal.show('send-invite-modal')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.sendInvite') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2"
                    v-if="allowUpdateDrivers && selectedRows.length && this.teamMemberType === 'True'"
                    @click="$bvModal.show('send-notification-modal')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.sendNotification') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="allowUpdateDrivers && selectedRows.length"
                    @click="showDeactivateModal = true">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ teamMemberType === 'True' ? $t('teamPage.deactivate') : $t('teamPage.activate') }}</p>
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="data-table team-data-table table-custom-border">
              <div class="bg-white rounded">
                <div v-if="contentLoading" class="d-flex align-items-center px-3 py-3">
                  <b-skeleton v-for="n in 4" :key="`view-tab-skeleton-${n}`" width="80px" height="26px"
                    class="mr-3 mb-0"></b-skeleton>
                </div>
                <v-tabs v-else ref="viewsTabs" :key="`tabs-${tableViews.length}`"
                  class="team-tabs mb-0" v-model="activeViewIndex" show-arrows>
                  <v-tab v-for="(view, index) in tableViews" :class="index === lastDefaultViewIndex ? 'with-border' : ''"
                    :key="`${viewKey(view)}-${index}`">
                    {{ view.name }} <span
                      v-if="view.name.toLowerCase() === 'active' || view.name.toLowerCase() === 'inactive'"
                      class="f-12 ml-1">{{ view.name.toLowerCase() === 'active' ? `(${activeCount})` :
                        `(${inactiveCount})` }}</span>
                  </v-tab>
                  <v-tab key="add-view" @click.stop="openAddView()">
                    <span class="add-view-plus mr-1">+</span> {{ $t('teamPage.addView') }}
                  </v-tab>
                </v-tabs>
              </div>
              <div class="bg-white pt-3 pt-sm-4 rounded" v-if="contentLoading">
                <div class="table_row team_table_row">
                  <div class="pb-4" style="height: calc(100vh - 230px); overflow: hidden;">
                    <b-skeleton-table :rows="17" :columns="7"
                      :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                  </div>
                </div>
              </div>
              <div class="bg-white pt-3 pt-sm-4 rounded" v-else-if="activeViewIndex < tableViews.length">
                <div class="table_row team_table_row">
                  <div class="equipment-border filter-box">
                    <div class="d-flex mb-4 px-3 px-sm-4">
                      <b-form-group class="text-left label font-weight-normal search-field mb-0">
                        <b-input-group class="username-input-field">
                          <b-form-input type="text" :placeholder="$t('teamPage.search')" v-model="filterFields.search_field"
                            class="unit f-12" @keyup.enter="getTeamMemberData()"></b-form-input>
                          <b-input-group-append>
                            <b-button variant="primary" @click="getTeamMemberData()">
                              <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                      <div class="ml-auto d-none d-sm-flex align-items-center flex-wrap" v-if="!allowShowBasicDriver">
                        <button class="btn btn-filter-section" v-if="!isDefaultActiveView" @click="deleteView()">
                          <div class="d-flex align-items-center">
                            <svg width="19" height="20" viewBox="0 0 19 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 5.15704H17.6139" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path
                                d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.23175 9.3065V14.8466" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path d="M11.385 9.3065V14.8466" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            </svg>
                            <p class="mb-0 ml-2">{{ $t('teamPage.delete') }}</p>
                          </div>
                        </button>
                        <div class="position-relative mt-0" :class="!isDefaultActiveView ? 'ml-2':''">
                          <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                            {{ activeFiltersCount }}
                          </div>
                          <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                            <div class="d-flex align-items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-sliders-horizontal w-4 h-4"
                                data-id="element-964">
                                <line x1="21" x2="14" y1="4" y2="4"></line>
                                <line x1="10" x2="3" y1="4" y2="4"></line>
                                <line x1="21" x2="12" y1="12" y2="12"></line>
                                <line x1="8" x2="3" y1="12" y2="12"></line>
                                <line x1="21" x2="16" y1="20" y2="20"></line>
                                <line x1="12" x2="3" y1="20" y2="20"></line>
                                <line x1="14" x2="14" y1="2" y2="6"></line>
                                <line x1="8" x2="8" y1="10" y2="14"></line>
                                <line x1="16" x2="16" y1="18" y2="22"></line>
                              </svg>
                              <p class="mb-0 ml-2">{{ $t('teamPage.filters') }}</p>
                            </div>
                          </button>
                        </div>
                        <div class="table-columns-section ml-2 mt-0" @click="showColumns = true">
                          <button class="btn btn-table-columns-section">
                            <div class="d-flex align-items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-columns2 w-4 h-4" data-id="element-961">
                                <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                                <path d="M12 3v18"></path>
                              </svg>
                              <p class="mb-0 ml-2">{{ $t('teamPage.columns') }}</p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="d-flex">
                                        <b-form-group label="Groups" class="text-left w-equipment-box"
                                            :style="{ width: `${widthBox}px` }">
                                            <v-select multiple class="mb-4" :options="teamDispatchGroups"
                                                v-model="searchGroups" :reduce="(option) => option.id" />
                                        </b-form-group>
                                       
                                    </div> -->
                  </div>

                  <b-table v-if="tableViews.length" ref="tableRef" class="mt-2" responsive :sticky-header="'calc(100vh - 330px)'"
                    :fields="allowShowBasicDriver ? showBasicDriverFields : visibleFields" :items="items" hover
                    :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true"
                    :busy.sync="isBusy" selectable select-mode="multi" no-select-on-click @row-selected="onRowSelected"
                    :show-empty="emptyTable">
                    <template #head(selected)="">
                      <b-form-checkbox class="pl-0 w-fit-content" @change="selectRows($event)" v-model="allRowsSelected">
                      </b-form-checkbox>
                    </template>
                    <template #cell(integration)="data">
                      <b-img v-if="data.value" width="20" height="20" :src="require('@/assets/Check.svg')"></b-img>
                      <b-img v-else width="20" height="20" :src="require('@/assets/Close.svg')"></b-img>
                    </template>
                    <template #cell(selected)="data">
                      <b-form-checkbox class="pl-0 w-fit-content" @change="checked(data.index, data.rowSelected)"
                        v-model="data.rowSelected">
                      </b-form-checkbox>
                    </template>
                    <template #cell(default_trailer)="data">
                     <div v-if="getAllowedTrailers" class="d-flex align-items-center">
                          <div class="table-tags mr-2">{{ data.item.assigned_trailers[0] }}</div>
                          <v-app>
                            <v-tooltip bottom v-if="data.item.assigned_trailers.length > 1">
                              <template #activator="{ on, attrs }">
                                <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.item.assigned_trailers.length - 1 }}</div>
                              </template> <span v-html="data.item.assigned_trailers.slice(1).join('<br>')"></span>
                            </v-tooltip>
                          </v-app>
                        </div>
                        <p class="mb-0" v-else>{{data.value}}</p>
                    </template>
                    <template #cell(notes)="data">
                      <div v-if="data.value">
                        <span @click="showNotesSection(data.item.id)" v-html="`${data.value}`"
                          class="notes-item cursor-pointer"></span>
                      </div>
                      <span v-else>-</span>
                    </template>
                    <template #cell(#)="data">
                      <!-- `data.value` is the value after formatted by the Formatter -->
                      <b-img class="rounded-circle small_img" style="width: 40px; height: 40px; margin: 3px" :src="data.item.Image
                        ? data.item.Image
                        : require('@/assets/user.png')
                        " />
                    </template>
                    <template #cell(tags)="data">
                      <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{ data.value[0] }}</div>
                        <v-app>
                          <v-tooltip bottom v-if="data.value.length > 1">
                            <template #activator="{ on, attrs }">
                              <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                            </template> <span v-html="data.value.slice(1).join('<br>')"></span>
                          </v-tooltip>
                        </v-app>
                      </div>
                      <p class="mb-0" v-else>-</p>
                    </template>
                    <template #cell(name)="data">
                      <!-- `data.value` is the value after formatted by the Formatter -->
                      <div>
                        <p class="text_primary cursor-pointer mb-0" v-if="!allowShowBasicDriver"
                          @click="setDriverData(data.item.id)">{{ data.value }}
                        </p>
                        <p class="mb-0" v-else>{{ data.value }}</p>
                      </div>
                    </template>
                    <template #cell(num_docs)="data">
                      <span :style='data.item.color' class="docs-circle">{{ data.value }}</span>
                    </template>
                    <template #cell(status)="data">
                      <b-button class="export table_btn pe-none d-flex justify-content-center align-items-center"
                        :variant="data.item.status === 'Active' ? 'primary-status' : 'secondary-status'">
                        <p class="mb-0">{{ data.value }}</p>
                      </b-button>
                    </template>
                    <template #cell(app_user)="data">
                      <b-img width="20" height="20" :src="data.item.last_login !== '-' ? require('@/assets/Check.svg') :
                        require('@/assets/check-yellow.svg')
                        "></b-img>
                    </template>
                  </b-table>
                  <div class="entries-pagination px-0 px-sm-2">
                    <div class="d-flex align-items-center flex-wrap">
                      <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                      </div>
                      <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                      <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Import CSV Modal  -->
    <b-modal id="modal-bulk-upload" centered hide-footer :title="$t('teamPage.importCsvTitle')" @shown="resetField" no-close-on-backdrop>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('teamPage.importCsvTitle') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('teamPage.closeModal') }}
        </b-button>
      </template>
      <div class="d-block text-center">
        <b-row class="import-excel-modal mx-0">
          <b-col cols="12" class="px-0">
            <div class="upload-btn-wrapper mt-0">
              <b-img :src="require('@/assets/drop.svg')"></b-img>
              <button class="foo" v-if="!fileName">
                {{ $t('teamPage.dropDocument') }}
              </button>
              <button v-else class="foo">{{ fileName }}</button>
              <input ref="docFile" type="file" name="docFile" @change="handleFileUpload" accept=".csv" />
              <p v-if="errors && errors.document" class="field-error">
                {{ errors.document }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" class="text-left cursor-pointer mt-2 pt-1 pl-1">
            <a class="download-sample-file" href="/files/sample-drivers.csv" download="sample-drivers.csv">
              <b-img :src="require('@/assets/sample-file.svg')"></b-img>
              {{ $t('teamPage.downloadSampleFile') }}
            </a>
          </b-col>
        </b-row>
      </div>
      <div class="text-right modal-footer border-0 p-0">
        <b-button class="mx-0 mr-3 h-40px w-100px" @click="$bvModal.hide('modal-bulk-upload')"
          variant="secondary">{{ $t('teamPage.cancel') }}</b-button>
        <b-button class="mx-0 mb-0 h-40px w-100px" variant="primary" @click="bulkUploadTeamMembers">{{ $t('teamPage.save') }}</b-button>
      </div>
    </b-modal>
    <!-- Bulk Upload Errors Modal -->
    <b-modal id="modal-bulk-upload-errors" centered hide-footer size="md" no-close-on-backdrop>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('teamPage.csvImportErrors') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('teamPage.closeModal') }}
        </b-button>
      </template>
      <div class="bulk-upload-errors-container">
        <p v-if="bulkUploadSummary" class="mb-3 font-weight-bold">{{ bulkUploadSummary }}</p>
        <div class="errors-list" style="max-height: 400px; overflow-y: auto;">
          <div v-for="(error, index) in bulkUploadErrors" :key="index" class="error-item mb-2 p-2"
            style="background: #fff3f3; border-left: 3px solid #dc3545; border-radius: 4px;">
            <p class="mb-0"><strong>{{ error.row }}:</strong> {{ error.message }}</p>
          </div>
        </div>
      </div>
      <div class="text-right modal-footer border-0 p-0 mt-3">
        <b-button class="mx-0 h-40px w-100px" @click="$bvModal.hide('modal-bulk-upload-errors')"
          variant="primary">{{ $t('teamPage.close') }}</b-button>
      </div>
    </b-modal>
    <!-- Set Password Modal  -->
    <b-modal id="modal-set-password" no-close-on-esc centered no-close-on-backdrop
      :footer-class="'d-block p-3 m-0'" :title="$t('teamPage.setPasswordTitle')" @shown="clearPasswordFields"
      v-if="allowUpdateDrivers">
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('teamPage.setPasswordForDrivers') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('teamPage.closeModal') }}
        </b-button>
      </template>

      <div class="text-center">
        <b-form-group label="" class="text-left password show-password-section">
          <b-form-input :type="showPassword ? 'text' : 'password'" :placeholder="$t('teamPage.enterPassword')" required
            v-model="setPasswordField" />
          <b-icon :icon="showPassword ? 'eye-fill' : 'eye-slash-fill'" @click="showPassword = !showPassword"></b-icon>
          <p v-if="errors && errors.setPasswordField" class="field-error">
            {{ errors.setPasswordField }}
          </p>
        </b-form-group>
      </div>
      <template #modal-footer>
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
          <b-button class="mx-0 mr-3 h-40px w-100px m-0"
            @click="$bvModal.hide('modal-set-password'); showPassword = false" variant="secondary">{{ $t('teamPage.cancel') }}</b-button>
          <div class="d-flex align-items m-0">
            <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
              @click="setPasswordforDrivers">{{ $t('teamPage.save') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <TableColumns :defaultView="isDefaultActiveView" :showColumns="showColumns" :fields="availableColumns"
      :viewColumns="tableViews.length > 0 ? tableViews[activeViewIndex] : []"
      @getUpdatedFieldsList="getUpdatedFieldsList($event)" @updateFields="updateFields($event)"
      @resetTableFields="resetTableFields()" @resetData="showColumns = false" />
    <EditTeamMember :driverID="driverID" :states="states" :options="options" @updateDriver="resetDriverList"
      @updateData="getTeamMemberData()" @resetDriver="driverID = ''; setNotesSection = false"
      :setNotesSection="setNotesSection" />
    <SendInvite ref="sendInvite" v-if="!driverID" :title="$t('teamPage.sendInviteSelected')"
      @sendInvite="sendInviteInBulk($event)" />
    <AddTeamMember :allowAddTeamMember="allowAddTeamMember" :states="states" @close="allowAddTeamMember = false"
      @getNewData="getTeamMemberNewData($event)" />
    <AddTags :ids="selectedRows.map((data) => data.id)" v-if="selectedRows.length"
      @close="$refs.tableRef.clearSelected(); selectedRows = []" @updateTags="getTeamMemberData()" :type="'driver'" />
    <DeleteModal v-if="showDeactivateModal" @confirm="changeDriverStatusItem($event)"
      :message="teamMemberType === 'True' ? $t('teamPage.confirmDeactivate') : $t('teamPage.confirmActivate')"
      :removeMessage="teamMemberType === 'True' ? $t('teamPage.deactivate') : $t('teamPage.activate')" />
    <DeleteModal v-if="showDeleteViewModal" @confirm="confirmDeleteView($event)" :message="$t('teamPage.confirmDeleteView')"/>
    <SendMessagetoDrivers :ids="selectedRows.map((data) => data.id)"
      @close="$refs.tableRef.clearSelected(); selectedRows = []" v-if="selectedRows.length" />
    <BulkDivisionUpdate :ids="selectedRows.map((data) => data.id)"
      @close="$refs.tableRef.clearSelected(); selectedRows = []" v-if="selectedRows.length"
      @updateDivision="getTeamMemberData()" :type="'driver'" />
    <LockTrailerAndVehicle :driverIds="selectedRows.map((data) => data.id)"
      @close="$refs.tableRef.clearSelected(); selectedRows = []" v-if="selectedRows.length"
      @updateDrivers="getTeamMemberData()" :title="lockPopupTitle" />
    <b-modal id="modal-filter" centered no-close-on-backdrop no-close-on-esc
      :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block p-3 m-0'"
      :header-class="'align-items-center'" scrollable>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('teamPage.filtersModalTitle') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('teamPage.closeModal') }}
        </b-button>
      </template>
      <div class="body">
        <b-form-group :label="$t('teamPage.filterType')" v-if="checkTableField('driver_type')" class="text-left select_arrow label">
          <b-form-select class="input f-12" :options="driverTypeOptions" v-model="filterFields.driver_type" @change="getTeamMemberData()"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('teamPage.filterDocs')" v-if="checkTableField('num_docs')" class="text-left select_arrow label mb-3">
          <b-form-select type="text" class="input f-12" :options="yesNoOptions" v-model="filterFields.doc" @change="getTeamMemberData()"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('teamPage.filterTags')" class="text-left w-equipment-box mb-3">
          <v-select multiple :options="allTags" class="f-12" :reduce="(option) => option.id" v-model="filterFields.tags"
            @input="getTeamMemberData()" />
        </b-form-group>
        <b-form-group :label="$t('teamPage.filterDivision')" class="text-left w-equipment-box mb-3">
          <v-select multiple :options="allDivisions" class="f-12" :reduce="(option) => option.id"
            v-model="filterFields.division" @input="getTeamMemberData()" />
        </b-form-group>
        <b-form-group :label="$t('teamPage.filterAppUsers')" class="text-left select_arrow label mb-3">
          <b-form-select type="text" class="input f-12" v-model="filterFields.last_login" @change="getTeamMemberData()"
            :options="yesNoOptions"></b-form-select>
        </b-form-group>
        <template v-for="field in driverCustomFields">
          <b-form-group v-if="field.field_type === 'text' || field.field_type === 'number' || field.field_type === 'date'" :key="`cf-input-${field.id}`"
            :label="field.name" class="text-left label mb-3">
            <b-form-input class="input f-12" :type="field.field_type === 'number' ? 'number' : field.field_type === 'date' ? 'date' : 'text'"
              v-model="filterFields[`cf_${field.id}`]" @keyup.enter="getTeamMemberData()" @change="getTeamMemberData()" />
          </b-form-group>
          <b-form-group v-else-if="field.field_type === 'select' || field.field_type === 'multi_select'"
            :key="`cf-select-${field.id}`" :label="field.name" class="text-left w-equipment-box mb-3">
            <v-select :options="field.options" class="f-12" v-model="filterFields[`cf_${field.id}`]"
              :multiple="field.field_type === 'multi_select'" :reduce="(option) => option" @input="getTeamMemberData()" />
          </b-form-group>
        </template>
      </div>
      <template #modal-footer="">
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
          <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
            @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('teamPage.reset') }}</b-button>
          <b-button class="mx-0 h-40px w-100px m-0 m-0" :variant="isDefaultActiveView ? 'secondary' : 'primary'" block
            @click="onFilterModalSave()">{{ isDefaultActiveView ? $t('teamPage.close') : $t('teamPage.save') }}</b-button>
        </div>
      </template>
    </b-modal>
    <AddTableViewModal :table="'drivers'" :seedColumns="currentColumnsState" :seedFilters="currentFiltersQuery"
      @created="onViewCreated" @cancel="activeViewIndex = 0"/>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { checkEmail } from "../../services/helper";
import * as moment from "moment-timezone";
import EditTeamMember from "@/components/TeamMember/EditTeamMember.vue";
import SendInvite from "@/components/TeamMember/SendInvite.vue"
import AddTeamMember from "@/components/TeamMember/AddTeamMember.vue";
import AddTags from "@/components/Shared/AddTags.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import TableColumns from "@/components/Shared/TableColumns.vue";
import SendMessagetoDrivers from "@/components/TeamMember/SendMessagetoDrivers.vue";
import BulkDivisionUpdate from "@/components/driver/BulkDivisionUpdate.vue";
import LockTrailerAndVehicle from "@/components/driver/LockTrailerAndVehicle.vue";
import AddTableViewModal from "@/components/Shared/TableViews/AddTableViewModal.vue";
import { viewIndexFromQuery, setViewInUrl } from "@/services/helper";

export default {
  name: "Team-list",
  components: {
    vSelect,
    TableColumns,
    EditTeamMember,
    SendInvite,
    AddTeamMember,
    AddTags,
    DeleteModal,
    SendMessagetoDrivers,
    BulkDivisionUpdate,
    LockTrailerAndVehicle,
    AddTableViewModal
  },
  data() {
    return {
      setNotesSection: false,
      isTableMounted: false,
      showColumns: false,
      states: [],
      countries: [],
      lockPopupTitle: "Lock Trailer",
      showDeactivateModal: false,
      showDeleteViewModal: false,
      allowAddTeamMember: false,
      document: null,
      showAdditionalSetting: false,
      sortBy: undefined,
      emptyTable: false,
      activeCount: 0,
      inactiveCount: 0,
      sortDesc: undefined,
      isBusy: false,
      setPasswordField: "",
      showPassword: false,
      checkEmail,
      positionText: "",
      fileName: null,
      perPage: 25,
      currentPage: 1,
      allRowsSelected: false,
      driverID: null,
      widthBox: 100,
      items: [],
      allTags: [],
      driverCustomFields: [],
      tableViews: [],
      activeViewIndex: 0,
      // ?view= from the url, honoured on the first load only.
      requestedViewId: this.$route.query.view || null,
      activeViewKey: 1,
      ADD_VIEW_KEY: '__add_view__',
      availableColumns: [],
      activeViewFiltersRaw: '',
      bulkUploadErrors: [],
      bulkUploadSummary: '',
      errors: {
        document: null,
      },
      teamDispatchGroups: [],
      filterFields: {
        search_field: '',
        driver_type: '',
        last_login: '',
        app_user: '',
        division: [],
        doc: '',
        tags: []
      },
      bindProps: {
        mode: "international",
        autoFormat: true,
        preferredCountries: ["US", "CA", "MX"],
        inputOptions: {
          placeholder: "Enter a phone no.",
          maxlength: 30,
        },
        dropdownOptions: {
          showSearchBox: true,
          showDialCodeInList: true,
          showFlags: true,
          showDialCodeInSelection: true,
          width: "300px",
        },
      },
      statusOptions: [
        {
          value: "",
          text: "",
        },
        {
          value: "True",
          text: "Active",
        },
        {
          value: "False",
          text: "Inactive",
        },
      ],
      appUserOptions: [
        {
          value: "",
          text: "",
        },
        {
          value: "True",
          text: "Active",
        },
        {
          value: "False",
          text: "Inactive",
        },
      ],
      showBasicDriverFields: [
        {
          key: "name",
          label: "Name",
          sortable: true,
          tdClass: "align-middle",
          visible: true,
          disabled: true,
          field: "text",
          stickyColumn: true,
          thClass: 'font-table-weight-bold'
        },
        {
          label: "Phone",
          key: "phone",
          sortable: true,
          tdClass: "align-middle",
          visible: true,
          disabled: false,
          field: "text",
          thClass: 'font-table-weight-bold'
        },
        {
          key: "default_vehicle",
          label: "Vehicle",
          sortable: true,
          visible: false,
          disabled: false,
          field: "text",
          thClass: 'font-table-weight-bold'
        },
        {
          key: "default_trailer",
          label: "Trailer",
          sortable: true,
          visible: false,
          disabled: false,
          field: "text",
          thClass: 'font-table-weight-bold'
        }
      ],
      fields: [],
      selected: null,
      options: [
        {
          value: null,
          text: "",
        },
        // {
        //     value: "Maintenance",
        //     text: "Maintenance",
        // },
        {
          value: "Driver",
          text: "Driver",
        },
      ],
      pageOptions: [
        {
          value: 10,
          text: "10",
        },
        {
          value: 25,
          text: "25",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
      ],
      isPhoneValid: false,
      selectedRows: [],
      rows: 1,
      teamMemberType: "True",
      newTeamMember: {
        first_name: "",
        last_name: "",
        role: "Driver",
        email: "",
        username: "",
        phone: "",
        password: "",
        inviteNewMember: false,
        license_number: "",
        license_state: {
          id: 54,
          country: 1,
        },
      },
    };
  },

  computed: {
    ...mapGetters([
      "allDrivers",
      "dispatchGroups",
      "licenseInventory",
      "company",
      "allCountries",
      "tags",
      "userCompany",
      "divisions",
      "rolePermissions",
      "user"
    ]),
    getAllowedTrailers(){
      return this.company[0]?.number_of_allowed_trailers > 1
    },
    allDivisions() {
      return this.divisions.map((item) => {
        return {
          id: item.id,
          label: item.division,
        }
      })
    },
    driverTypeOptions() {
      return [
        { value: '', text: '' },
        { value: 'Company', text: this.$t('teamPage.typeCompany') },
        { value: 'Owner Operator', text: this.$t('teamPage.typeOwnerOperator') },
      ];
    },
    yesNoOptions() {
      return [
        { value: '', text: '' },
        { value: 'True', text: this.$t('teamPage.yes') },
        { value: 'False', text: this.$t('teamPage.no') },
      ];
    },
    visibleFields() {
      if (!this.allowUpdateDrivers) return this.fields.filter(field => field.visible && field.key !== 'selected')
      return this.fields.filter(field => field.visible)
    },
    isDefaultActiveView() {
      const v = this.tableViews[this.activeViewIndex];
      return !v || v.id == null || v.is_default === true;
    },
    contentLoading() {
      return !this.isTableMounted || !this.tableViews.length;
    },
    lastDefaultViewIndex() {
      let last = -1;
      this.tableViews.forEach((v, idx) => {
        if (v && (v.id == null || v.is_default === true)) last = idx;
      });
      return last;
    },
    currentColumnsState() {
      const defView = this.tableViews.find(v => v.id == null || v.is_default === true);
      const source = defView && Array.isArray(defView.columns) ? defView.columns : this.fields;
      return (source || []).map(c => ({ key: c.key, visible: !!c.visible }));
    },
    currentFiltersQuery() {
      const parts = [];
      Object.keys(this.filterFields || {}).forEach(key => {
        const val = this.filterFields[key];
        if (val === '' || val === null || val === undefined) return;
        if (Array.isArray(val)) {
          if (val.length === 0) return;
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val.join(','))}`);
        } else {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
        }
      });
      return parts.join('&');
    },
    activeFiltersCount() {
      return Object.keys(this.filterFields).reduce((count, key) => {
        if (key === 'tags' || key === 'division') {
          return count + (this.filterFields[key].length > 0 ? 1 : 0);
        } else if (
          this.filterFields[key] !== '' &&
          this.filterFields[key] !== null
        ) {
          return count + 1;
        }
        return count;
      }, 0);
    },
    allowAddDriver() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][3].allow
    },
    allowUpdateDrivers() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][2].allow
    },
    allowShowBasicDriver() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && (this.rolePermissions['Drivers'][0].allow && !this.rolePermissions['Drivers'][1].allow)
    },
    allowShowDrivers() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][1].allow
    },
    allowImportDrivers() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][5].allow
    },
    allowExportDrivers() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][6].allow
    },
  },
  methods: {
    ...mapActions([
      "getAllDrivers",
      "sendInvite",
      "setNotification",
      "postExcelData",
      "addBulkData",
      "getAllCountries",
      "setLoader",
      "getAllTags",
      "getDriversExportData",
      "setPasswordforAllDrivers",
      "sendBulkInvite",
      "changeDriverStatus",
      "getCustomFields",
      "getTableViews",
      "updateTableView",
      "deleteTableView"
    ]),
    async loadTableViews() {
      try {
        const data = await this.getTableViews('drivers');
        this.availableColumns = data.available_columns || [];
        this.tableViews = data.views || [];
        const defaultIndex = this.tableViews.findIndex(v => v.id == null || v.is_default === true);
        const requestedIndex = viewIndexFromQuery(this.tableViews, this.requestedViewId);
        this.requestedViewId = null;
        const targetIndex = requestedIndex >= 0 ? requestedIndex : (defaultIndex >= 0 ? defaultIndex : 0);
        if (this.activeViewIndex !== targetIndex) {
          this.activeViewIndex = targetIndex;
        } else {
          this.applyActiveView();
        }
        this.refreshTabSlider();
      } catch (e) {
        await this.setNotification({
          msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('teamPage.failedLoadViews'),
          type: 'error',
          color: 'red',
        });
      }
    },
    refreshTabSlider() {
      const tick = (delay) => {
        setTimeout(() => {
          const tabs = this.$refs.viewsTabs;
          if (!tabs || !tabs.$el) {
            if (typeof window !== 'undefined') window.dispatchEvent(new Event('resize'));
            return;
          }
          // Force a synchronous layout read so the ResizeObserver sees a real box.
          // eslint-disable-next-line no-unused-vars
          const _h = tabs.$el.offsetHeight;
          // eslint-disable-next-line no-unused-vars
          const _w = tabs.$el.offsetWidth;
          if (typeof tabs.onResize === 'function') tabs.onResize();
          if (typeof tabs.callSlider === 'function') tabs.callSlider();
          const inner = tabs.$el.querySelector('.v-tabs-bar') || tabs.$el.querySelector('.v-slide-group');
          if (inner && inner.__vue__) {
            const vc = inner.__vue__;
            if (typeof vc.onResize === 'function') vc.onResize();
            if (typeof vc.callSlider === 'function') vc.callSlider();
          }
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new Event('resize'));
          }
        }, delay);
      };
      this.$nextTick(() => {
        tick(0);
        tick(80);
        tick(250);
        tick(600);
      });
    },
    applyActiveView() {
      const view = this.tableViews[this.activeViewIndex];
      if (!view) return;
      setViewInUrl(this.$router, this.$route, view);
      this.refreshTabSlider();
      const ordered = (view.columns || [])
        .filter(c => c && c.visible)
        .slice()
        .sort((a, b) => {
          const ao = a.display_order == null ? -Infinity : a.display_order;
          const bo = b.display_order == null ? -Infinity : b.display_order;
          return ao - bo;
        });
      this.fields = ordered.map(col => ({
        key: col.key,
        label: col.label,
        field: col.field_type === 'dropdown' ? 'Dropdown' : (col.field_type || 'text'),
        visible: true,
        sortable: !!col.sortable,
        disabled: !!col.disabled,
        stickyColumn: !!col.sticky,
        thClass: 'font-table-weight-bold',
        ...(col.key === 'selected' ? { thStyle: { minWidth: '20px', width: '20px' } } : {}),
      }));
      this.activeViewFiltersRaw = view.filters || '';
      this.applyFiltersFromView(view.filters || '');
      this.currentPage = 1;
      this.getTeamMemberData();
    },
    applyFiltersFromView(filtersQuery) {
      const blank = {
        search_field: '',
        driver_type: '',
        last_login: '',
        app_user: '',
        division: [],
        doc: '',
        tags: [],
      };
      this.driverCustomFields.forEach(f => { blank[`cf_${f.id}`] = ''; });
      this.filterFields = blank;
      if (!filtersQuery) return;
      const params = new URLSearchParams(filtersQuery);
      params.forEach((value, key) => {
        if (!(key in this.filterFields)) return;
        if (key === 'tags' || key === 'division') {
          this.filterFields[key] = value ? value.split(',').map(v => isNaN(+v) ? v : +v) : [];
        } else {
          this.filterFields[key] = value;
        }
      });
    },
    openAddView() {
      this.$bvModal.show('modal-add-table-view');
    },
    viewKey(view) {
      if (!view) return '';
      return view.id != null ? `view-${view.id}` : `default-${view.slug || 'default'}`;
    },
    defaultViewKey() {
      const defView = this.tableViews.find(v => v.id == null || v.is_default === true);
      return defView ? this.viewKey(defView) : (this.tableViews[0] ? this.viewKey(this.tableViews[0]) : null);
    },
    deleteView() {
      const view = this.tableViews[this.activeViewIndex];
      if (!view || view.id == null || view.is_default === true) return;
      this.showDeleteViewModal = true;
    },
    async confirmDeleteView(status) {
      if (!status) {
        this.showDeleteViewModal = false;
        return;
      }
      const view = this.tableViews[this.activeViewIndex];
      if (!view || view.id == null) {
        this.showDeleteViewModal = false;
        return;
      }
      try {
        this.setLoader(true);
        await this.deleteTableView({ table: 'drivers', id: view.id });
        await this.setNotification({
          msg: this.$t('teamPage.viewDeleted', { name: view.name }),
          type: 'success',
          color: 'green',
        });
        this.showDeleteViewModal = false;
        await this.loadTableViews();
        const defaultIndex = this.tableViews.findIndex(v => v.id == null || v.is_default === true);
        const targetIndex = defaultIndex >= 0 ? defaultIndex : 0;
        if (this.activeViewIndex !== targetIndex) {
          this.activeViewIndex = targetIndex;
        } else {
          this.applyActiveView();
        }
        this.setLoader(false);
      } catch (e) {
        this.setLoader(false);
        this.showDeleteViewModal = false;
        await this.setNotification({
          msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('teamPage.failedDeleteView'),
          type: 'error',
          color: 'red',
        });
      }
    },
    async onViewCreated(view) {
      await this.loadTableViews();
      let foundIdx = -1;
      if (view && view.id != null) {
        foundIdx = this.tableViews.findIndex(v => v.id === view.id);
      }
      if (foundIdx < 0) foundIdx = this.tableViews.length - 1;
      const targetIndex = foundIdx >= 0 ? foundIdx : 0;
      if (this.activeViewIndex !== targetIndex) {
        this.activeViewIndex = targetIndex;
      } else {
        this.applyActiveView();
      }
    },
    async loadDriverCustomFields() {
      try {
        const list = await this.getCustomFields('driver');
        this.driverCustomFields = (list || [])
          .filter(f => f.model === 'driver')
          .slice()
          .sort((a, b) => (a.order || 0) - (b.order || 0));
        this.driverCustomFields.forEach(f => {
          const key = `cf_${f.id}`;
          if (!Object.prototype.hasOwnProperty.call(this.filterFields, key)) {
            this.$set(this.filterFields, key, '');
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    resetCustomFieldFilters() {
      this.driverCustomFields.forEach(f => {
        this.$set(this.filterFields, `cf_${f.id}`, '');
      });
    },
    async getUpdatedFieldsList(updatedFields) {
      this.fields = updatedFields
      await this.persistColumnsForActiveView(updatedFields)
    },
    activeView() {
      return this.tableViews[this.activeViewIndex] || null;
    },
    async persistColumnsForActiveView(updatedFields) {
      const view = this.tableViews[this.activeViewIndex];
      if (!view) return;
      const source = updatedFields || this.fields;
      const visibleCols = source.filter(f => !!f.visible);
      // Build a column list shaped like backend responses (carries catalog metadata).
      const catalogByKey = new Map((this.availableColumns || []).map(c => [c.key, c]));
      const newColumns = visibleCols.map((f, idx) => {
        const meta = catalogByKey.get(f.key) || {};
        return { ...meta, key: f.key, visible: true, display_order: idx };
      });
      // Update local view so the drawer's merge sees the latest state on reopen
      // (covers Default view, where we skip the backend PATCH per spec).
      this.$set(this.tableViews, this.activeViewIndex, { ...view, columns: newColumns });

      if (this.isDefaultActiveView) return; // default view: frontend-only per spec

      const payload = {
        // Send only the visible subset; absence = hidden in the saved view.
        columns: visibleCols.map((f, idx) => ({ key: f.key, visible: true, display_order: idx + 1 })),
      };
      try {
        const updated = await this.updateTableView({ table: 'drivers', id: view.id, payload });
        this.$set(this.tableViews, this.activeViewIndex, updated);
      } catch (e) {
        await this.setNotification({
          msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('teamPage.failedSaveCols'),
          type: 'error',
          color: 'red',
        });
      }
    },
    async onFilterModalSave() {
      this.$bvModal.hide('modal-filter');
      if (this.isDefaultActiveView) return; // default view: frontend-only
      await this.persistFiltersForActiveView();
    },
    async persistFiltersForActiveView() {
      const view = this.tableViews[this.activeViewIndex];
      if (!view || view.id == null) return;
      const newFilters = this.currentFiltersQuery || '';
      const payload = { filters: newFilters };
      try {
        const updated = await this.updateTableView({ table: 'drivers', id: view.id, payload });
        this.$set(this.tableViews, this.activeViewIndex, updated);
        this.activeViewFiltersRaw = updated.filters || '';
      } catch (e) {
        await this.setNotification({
          msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('teamPage.failedSaveFilters'),
          type: 'error',
          color: 'red',
        });
      }
    },
    changeDriverStatusItem(item) {
      if (item) {
        this.updateDriverStatus();
      }
      this.showDeactivateModal = false;
    },
    async updateDriverStatus() {
      try {
        this.setLoader(true);
        await this.changeDriverStatus({
          status: this.teamMemberType === 'True' ? false : true,
          driver_ids: this.selectedRows.map((data) => data.id)
        })
        await this.setNotification({
          msg: this.teamMemberType === 'True' ? this.$t('teamPage.driversDeactivated') : this.$t('teamPage.driversActivated'),
          type: "success",
          color: "green",
        });
        await this.getTeamMemberData();
        this.setLoader(false)
      }
      catch (e) {
        this.setLoader(false)
        console.log(e)
      }
    },
    checked(index, checked) {
      let tableRef = this.$refs.tableRef
      if (checked === true) tableRef.selectRow(index)
      else tableRef.unselectRow(index)
    },
    onRowSelected(items) {
      this.selectedRows = items
    },
    selectRows(checked) {
      if (checked) {
        this.$refs.tableRef.selectAllRows()
      }
      else {
        this.$refs.tableRef.clearSelected()
      }
    },
    async sendInviteInBulk(password) {
      try {
        this.setLoader(true)
        await this.sendBulkInvite({
          password: password ? password : null,
          driver_ids: this.selectedRows.map((data) => data.id)
        })
        this.setLoader(false)
        await this.setNotification({
          msg: this.$t('teamPage.invitesSent', { count: this.selectedRows.length }),
          type: "success",
          color: "green",
        });
        this.$bvModal.hide('send-invite-modal')
        this.$refs.sendInvite.resetForm()
        this.selectedRows = []
        this.$refs.tableRef.clearSelected()
      }
      catch (e) {
        console.log(e)
        this.setLoader(false)
      }
    },
    async resetFilterFields() {
      this.filterFields = {
        search_field: '',
        driver_type: '',
        app_user: '',
        last_login: '',
        division: [],
        doc: '',
        tags: [],
        status: '',
      }
      this.resetCustomFieldFilters()
      if (!this.isDefaultActiveView) {
        await this.persistFiltersForActiveView();
      }
      await this.getTeamMemberData();
    },
    setDriverData(id) {
      this.driverID = id
      this.setNotesSection = false
    },
    showNotesSection(id) {
      if (this.allowUpdateDrivers || this.allowShowDrivers) {
        this.driverID = id
        this.setNotesSection = true
      }
    },
    resetDriverList() {
      this.driverID = ""
      this.setNotesSection = false
      this.getTeamMemberData()
    },
    async updateFields(updatedFields) {
      this.fields = updatedFields
      await this.persistColumnsForActiveView(updatedFields)
    },
    async resetTableFields() {
      this.showColumns = false;
      if (this.isDefaultActiveView) {
        await this.loadTableViews();
        return;
      }
      const defaultView = this.tableViews.find(v => v && (v.id == null || v.is_default === true));
      if (!defaultView || !Array.isArray(defaultView.columns)) return;
      const defaultCols = defaultView.columns
        .slice()
        .sort((a, b) => {
          const ao = a.display_order == null ? -Infinity : a.display_order;
          const bo = b.display_order == null ? -Infinity : b.display_order;
          return ao - bo;
        });
      const catalogByKey = new Map((this.availableColumns || []).map(c => [c.key, c]));
      const newFields = defaultCols
        .filter(c => !!c.visible)
        .map(col => {
          const meta = catalogByKey.get(col.key) || {};
          return {
            key: col.key,
            label: meta.label || col.label,
            field: (meta.field_type || col.field_type) === 'dropdown' ? 'Dropdown' : (meta.field_type || col.field_type || 'text'),
            visible: true,
            sortable: !!(meta.sortable ?? col.sortable),
            disabled: !!(meta.disabled ?? col.disabled),
            stickyColumn: !!(meta.sticky ?? col.sticky),
            thClass: 'font-table-weight-bold',
            ...(col.key === 'selected' ? { thStyle: { minWidth: '20px', width: '20px' } } : {}),
          };
        });
      this.fields = newFields;
      await this.persistColumnsForActiveView(newFields);
    },
    checkTableField(key) {
      return this.fields.filter((item) => item.key === key)[0]?.visible
    },
    clearPasswordFields() {
      this.setPasswordField = ''
      this.errors = {}
    },
    async setPasswordforDrivers() {
      if (this.setPasswordField) {
        this.setLoader(true)
        try {
          await this.setPasswordforAllDrivers({
            password: this.setPasswordField,
            driver_ids: this.selectedRows.map((data) => data.id)
          })
          this.setLoader(false)
          await this.setNotification({
            msg: this.$t('teamPage.passwordsUpdated'),
            type: "success",
            color: "green",
          });
          this.showPassword = false
          this.$bvModal.hide('modal-set-password')
        }
        catch (e) {
          this.setLoader(false)
          console.log(e)
        }
      } else {
        this.errors = {
          setPasswordField: this.$t('teamPage.fieldRequired'),
        };
      }
    },
    async bulkUploadTeamMembers() {
      if (this.document) {
        this.setLoader(true)
        this.errors = {
          document: null,
        };
        try {
          let formData = new FormData();
          formData.append("file", this.document);
          formData.append("target_table", "TeamMember");
          formData.append("company_id", this.userCompany)
          const newMembers = await this.addBulkData(formData);
          if (newMembers) {
            await this.getTeamMemberData();
            await this.setNotification({
              msg: this.$t('teamPage.importSuccess'),
              type: "success",
              color: "green",
            });
            this.$bvModal.hide("modal-bulk-upload");
            this.setLoader(false)
          }
        } catch (e) {
          this.setLoader(false)
          if ("equipment" in e) {
            await this.setNotification({
              msg: e["equipment"][0],
              type: "error",
              color: "red",
            });
          } else if (typeof e === 'object' && e !== null) {
            // Parse row errors from the response
            this.bulkUploadErrors = [];
            this.bulkUploadSummary = e.summary || '';
            Object.keys(e).forEach((key) => {
              if (key.startsWith('row no:')) {
                this.bulkUploadErrors.push({
                  row: key,
                  message: e[key]
                });
              }
            });
            if (this.bulkUploadErrors.length > 0) {
              this.$bvModal.hide('modal-bulk-upload');
              this.$bvModal.show('modal-bulk-upload-errors');
            } else {
              await this.setNotification({
                msg: this.$t('teamPage.csvErrors'),
                type: "error",
                color: "red",
              });
            }
          } else {
            await this.setNotification({
              msg: "The Uploaded CSV has Wrong/Missing Fields.",
              type: "error",
              color: "red",
            });
          }
        }
      } else {
        this.errors = {
          document: this.$t('teamPage.fieldRequired'),
        };
      }
    },
    checkNum(data, phoneObject) {
      if (phoneObject.valid !== undefined) {
        this.isPhoneValid = phoneObject.valid;
      }
    },
    resetField() {
      this.$refs.docFile.value = null;
      this.fileName = null;
      this.document = null;
      this.errors = {
        document: null,
      };
    },
    handleFileUpload() {
      this.document = this.$refs.docFile.files[0];
      this.fileName = this.document.name;
    },
    async setTeamMemberType(type) {
      this.teamMemberType = type
      this.currentPage = 1
      await this.getTeamMemberData()
    },
    async downloadExcel() {
      try {
        this.setLoader(true)
        let url = ""
        let tags = ""
        Object.keys(this.filterFields).map((key) => {
          if (this.filterFields[key] && key != 'tags' && key != 'division') {
            if (key !== 'search_field') url += `${key}=${this.filterFields[key]}&`
            else {
              let searchList = ""
              if (this.fields.length > 0) this.fields.filter((item) => item.visible && item.field === 'text').map(({ key }, index) => index === 0 ? searchList = key : searchList += ',' + key)
              else searchList = 'name,email,username'
              url += `${key}=${encodeURIComponent(this.filterFields[key])}&search_list=${searchList}&`
            }
          }
          else if ((key === "tags" || key === "division") && this.filterFields[key].length > 0) {
            this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
            url += `${key}=${encodeURIComponent(tags)}&`
          }
        })
        if (this.sortBy) {
          url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}`
        }
        else {
          url += `sort_field=name&sort_order=asc`
        }
        if (this.activeViewFiltersRaw) {
          // Keys the user can clear from the filter modal are authoritative — don't
          // backfill them from the saved view (otherwise a cleared filter snaps back).
          const userControlledKeys = new Set(Object.keys(this.filterFields || {}));
          const existingKeys = new Set();
          url.split('&').forEach(part => {
            const eq = part.indexOf('=');
            if (eq > 0) existingKeys.add(part.slice(0, eq));
          });
          const viewParams = new URLSearchParams(this.activeViewFiltersRaw);
          viewParams.forEach((value, key) => {
            if (existingKeys.has(key) || userControlledKeys.has(key)) return;
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          });
        }
        url += "&role=driver"
        const { excel_file } = await this.getDriversExportData(url)
        window.open(process.env.VUE_APP_API_URL + excel_file, "_blank");
        await this.setNotification({
          msg: this.$t('teamPage.fileExported'),
          type: "success",
          color: "green",
        });
        this.setLoader(false)
      }
      catch (e) {
        this.setLoader(false)
        console.log(e)
      }
    },

    async getTeamMemberNewData(id = null) {
      this.allowAddTeamMember = false
      await this.getTeamMemberData()
      if (id) {
        this.driverID = id
        this.setNotesSection = false
      }
    },

    async getCountries(item) {
      await this.getAllCountries();
      this.countries = this.allCountries.map((item) => ({
        id: item.id,
        label: item.name,
      }));
      this.getStates(this.countries[0], item);
    },
    getStates(selectedOption, item) {
      this.states = this.allCountries
        .filter((country) => country.id === selectedOption.id)[0]
        .state.map((item) => ({
          id: item.id,
          label: item.name,
        }));
      if (this.states.length === 0) {
        this.newTeamMember.license_state.id = null;
      } else {
        if (this.newTeamMember.license_state && item) {
          this.newTeamMember.license_state.id = item;
        } else if (this.newTeamMember.license_state) {
          this.newTeamMember.license_state.id = this.states.filter(
            (state) => state.label === "-"
          )[0].id;
        }
      }
    },
    async getTeamMemberData() {
      try {
        this.isBusy = true
        let url = ""
        let tags = ""
        if (!this.isTableMounted && this.$route.query.driver) {
          this.filterFields.search_field = this.$route.query.driver
          if (this.$route.query.id) this.setDriverData(this.$route.query.id)
        }
        Object.keys(this.filterFields).map((key) => {
          if (this.filterFields[key] && key != 'tags' && key != 'division') {
            if (key !== 'search_field') url += `${key}=${this.filterFields[key]}&`
            else {
              let searchList = ""
              if (this.fields.length > 0) this.fields.filter((item) => item.visible && item.field === 'text').map(({ key }, index) => index === 0 ? searchList = key : searchList += ',' + key)
              // else searchList = 'unit_no,vin_no'
              else searchList = 'name,email,username'
              url += `${key}=${encodeURIComponent(this.filterFields[key])}&search_list=${searchList}&`
            }
          }
          else if ((key === "tags" || key === "division") && this.filterFields[key].length > 0) {
            this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
            url += `${key}=${encodeURIComponent(tags)}&`
          }
        })
        if (this.sortBy) {
          url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
        }
        else {
          url += `sort_field=name&sort_order=asc&`
        }
        url += `page=${this.currentPage}&page_size=${this.perPage}`
        if (this.activeViewFiltersRaw) {
          // Keys the user can clear from the filter modal are authoritative — don't
          // backfill them from the saved view (otherwise a cleared filter snaps back).
          const userControlledKeys = new Set(Object.keys(this.filterFields || {}));
          const existingKeys = new Set();
          url.split('&').forEach(part => {
            const eq = part.indexOf('=');
            if (eq > 0) existingKeys.add(part.slice(0, eq));
          });
          const viewParams = new URLSearchParams(this.activeViewFiltersRaw);
          viewParams.forEach((value, key) => {
            if (existingKeys.has(key) || userControlledKeys.has(key)) return;
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          });
        }
        const data = await this.getAllDrivers(url);
        // Only refresh the Active/Inactive counts when on a default view; on user views
        // they would reflect the view's filter scope, not the global driver pool, so we
        // keep the last default-view values instead.
        if (this.isDefaultActiveView) {
          this.activeCount = data.total_active_count >= 0 ? data.total_active_count : 0
          this.inactiveCount = data.total_inactive_count >= 0 ? data.total_inactive_count : 0
        }
        if (data.total_entries) {
          this.rows = data.total_entries
          {
            const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
            const end = this.perPage * (this.currentPage - 1) + data.queryset_count
            this.positionText = this.$t('teamPage.positionText', { start, end, total: data.total_entries })
          }
        }
        else {
          this.rows = 0
          this.positionText = this.$t('teamPage.emptyPosition')
        }
        const teamMemberData = [];
        this.allDrivers.map((member) => {
          let data
          if (this.allowShowBasicDriver) {
            data = {
              "#": member.id || "#",
              name: member.name,
              phone: member.phone ? member.phone : "-",
              default_vehicle: member.default_vehicle ? member.default_vehicle.unit_no : "-",
              default_trailer: member.default_trailer ? member.default_trailer.unit_no : "-",
              assigned_trailers: member.assigned_trailers.map((item)=>item.unit_no)
            }
          }
          else {
            let color;
            if (member.docs.length === 0) {
              color = "background:#C4C4C4";
            }
            else if (member.docs.filter((item) => item.expiry_date && parseInt((new Date(item.expiry_date) - new Date()) / (1000 * 60 * 60 * 24), 10) <= 0).length) {
              color = "background:#FF0000";
            }
            else if (member.docs.filter((item) => item.expiry_date && parseInt((new Date(item.expiry_date) - new Date()) / (1000 * 60 * 60 * 24), 10) <= 31 && parseInt((new Date(item.expiry_date) - new Date()) / (1000 * 60 * 60 * 24), 10) >= 1).length) {
              color = "background:#FFC800";
            }
            else {
              color = "background:#2CCE89";
            }
            const customFieldData = { custom: {} }
            if (Array.isArray(member.custom_fields)) {
              member.custom_fields.forEach((field) => {
                const matchedField = this.driverCustomFields.find((f) => f.id === field.id)
                if (matchedField) {
                  let v = matchedField.field_type === 'date'
                    ? (field.value ? moment(field.value).format("ll") : '')
                    : field.value;
                  if (Array.isArray(v)) v = v.length ? v.join(', ') : '-';
                  customFieldData.custom[matchedField.id] = (v != null && v !== '') ? String(v) : '-';
                }
              })
            }
            data = {
              "#": member.id || "#",
              name: `${member.user.first_name} ${member.user.last_name}`,
              username: member.user.username.split(`.${this.company[0].company_ID}`)[0],
              role: member.role,
              email: member.user.email ? member.user.email : "-",
              phone: member.phone ? member.phone : "-",
              num_docs: member.docs.length,
              license_number: member.license_number ? member.license_number : "-",
              dob: member.dob ? moment(member.dob).format("ll") : '-',
              driver_type: member.driver_type ? member.driver_type : '-',
              state: member.license_state?.name,
              default_vehicle: member.default_vehicle ? member.default_vehicle.unit_no : "-",
              default_trailer: member.default_trailer ? member.default_trailer.unit_no : "-",
              assigned_trailers: member.assigned_trailers.map((item)=>item.unit_no),
              app_user: member.user.is_active ? "Active" : "Inactive",
              status: member.status ? "Active" : "Inactive",
              id: member.id,
              Image: member.profile_picture,
              dispatch_group1: member.dispatch_group1,
              dispatch_group2: member.dispatch_group2,
              color,
              last_login: member.user.last_login ? moment(member.user.last_login).format("ll") : '-',
              tags: member.tags.map((tag) => tag.add_tag),
              division: member.division ? member.division.division : '-',
              last_active: member.last_active ? moment(member.last_active).fromNow() : '-',
              co_driver: member.co_driver ? member.co_driver.name : '-',
              lock_trailer: member.lock_trailer ? "Yes" : "No",
              lock_vehicle: member.lock_vehicle ? "Yes" : "No",
              activate_date: member.activate_date ? moment(member.activate_date).format("ll") : '-',
              inactive_date: member.inactive_date ? moment(member.inactive_date).format("ll") : '-',
              employee_id: member.employee_id ? member.employee_id : '-',
              notes: member.notes ? member.notes : null,
              integration: member.geo_tab_id ? true : member.ps_id ? true : member.samsara_id ? true : member.motive_id ? true : member.LT_id ? true : member.isaac_id ? true : false,
              ...customFieldData
            };
          }
          teamMemberData.push(data);
        });
        this.items = teamMemberData;
        if (this.items.length === 0) this.emptyTable = true
        else this.emptyTable = false
        this.isBusy = false
        this.isTableMounted = true
      }
      catch (e) {
        this.isBusy = false
        this.isTableMounted = true
        console.log(e)
      }
    },
    getCountryName(id) {
      return this.allCountries.filter((item) => item.id === id)[0].name;
    },
  },
  watch: {
    activeViewIndex(newVal, oldVal) {
      console.log(
        '[Team] activeViewIndex changed',
        'newVal=', newVal,
        'oldVal=', oldVal,
        'tableViews.length=', this.tableViews.length,
        'all view names=', this.tableViews.map(v => v.name),
        'resolved name (newVal-1)=', this.tableViews[newVal - 1] && this.tableViews[newVal - 1].name,
      );
      // Real views are at 0..tableViews.length-1; the Add View pseudo-tab is at tableViews.length.
      if (newVal >= 0 && newVal < this.tableViews.length) {
        this.applyActiveView();
      } else if (this.tableViews.length) {
        // v-tabs landed on the Add View pseudo-tab — snap back to a real view.
        const fallback = (oldVal >= 0 && oldVal < this.tableViews.length) ? oldVal : 0;
        console.warn('[Team] out-of-range activeViewIndex — snapping back to', fallback);
        this.$nextTick(() => { this.activeViewIndex = fallback; });
      }
    },
    perPage: {
      async handler() {
        await this.getTeamMemberData();
      },
      immediate: true,
    },
    currentPage: {
      async handler() {
        await this.getTeamMemberData();
      },
    },
    sortBy: {
      async handler() {
        await this.getTeamMemberData();
      },
    },
    sortDesc: {
      async handler() {
        await this.getTeamMemberData();
      },
    },
    filterFields: {
      handler() {
        this.currentPage = 1
      },
      deep: true
    },
    company: {
      async handler() {
        await this.getAllTags(this.userCompany);
        this.tags.map((item) => {
          this.allTags.push({
            id: item.add_tag,
            label: item.add_tag,
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    try {
      await this.getCountries(this.newTeamMember.license_state.id);
      await this.loadDriverCustomFields();
      await this.loadTableViews();
    } catch (error) {
      if (error.status === 403) {
        await this.setNotification({
          msg: this.$t('teamPage.notAllowed'),
          type: "error",
          color: "red",
        });
      }
    }
  },
};
</script>

<style>
.modal .col-form-label {
  font-size: var(--small) !important;
}

.team-page .select_arrow {
  position: relative;
}

.team-page .select_arrow svg {
  position: absolute;
  right: 10px;
  top: 40px;
}

.font-grey {
  font-size: 12px;
  color: #000000 !important;
}

/* @media (min-width: 992px) and (max-width: 1166px){
  .team-data-table{
    overflow-x: auto;
  }
  .team_table_row{
    width: 1050px;
  }
} */

.load-dropdown,
.load-dropdown-2,
.table-columns-dropdown,
.table-columns-section {
  margin-top: 3.5px;
}

.load-dropdown-2 .btn,
.table-columns-section .btn.btn-table-columns-section,
.table-columns-dropdown .btn.dropdown-toggle,
.btn.btn-filter-section,
.btn-dashboard-export-table-btn {
  background: #ffffff !important;
  border: 1px solid #e3e3e3 !important;
  border-radius: 5px;
  width: 54px;
  height: 40px;
}

.table-columns-dropdown .btn.dropdown-toggle,
.table-columns-section .btn.btn-table-columns-section,
.btn-dashboard-export-table-btn,
.btn.btn-filter-section {
  width: fit-content !important;
  color: #212529 !important
}

.load-dropdown .btn {
  background: #ffffff !important;
  border: none !important;
  padding: 0 !important;
}

.load-dropdown .btn::after,
.load-dropdown-2 .btn::after,
.table-columns-dropdown .btn::after,
.table-columns-section .btn::after {
  display: none;
}

.load-dropdown .dropdown-menu,
.load-dropdown-2 .dropdown-menu,
.table-columns-section .dropdown-menu {
  border: 0;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.load-dropdown .dropdown-menu.show {
  transform: translate3d(-135px, 20px, 0px) !important;
}

.load-dropdown-2 .dropdown-menu.show {
  transform: translate3d(-105px, 40px, 0px) !important;
}

.load-dropdown-3 .dropdown-menu.show {
  transform: translate3d(-138px, 40px, 0px) !important;
}

.load-dropdown .dropdown-item .btn,
.load-dropdown-2 .dropdown-item .btn,
.table-columns-section .dropdown-item .btn,
.table-columns-dropdown .dropdown-item .btn {
  width: 150px;
  height: 31px;
  background: #2cce89 !important;
  border: 0 !important;
  border-radius: 5px;
  font-size: 14px;
  color: #fff !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-columns-section .btn .dots>rect,
.table-columns-dropdown .btn .dots>rec {
  stroke: #212529 !important;
}

.load-dropdown .btn .dots,
.load-dropdown-2 .btn .dots {
  fill: #c4c4c4 !important;
}

.load-dropdown.show .btn,
.load-dropdown-2.show .btn,
.table-columns-dropdown.show .dropdown-toggle,
.table-columns-dropdown.active-dropdown .dropdown-toggle {
  border-color: #367BF6 !important;
}

.filter-section .btn>svg,
.filter-section .btn>div>svg {
  stroke: #212529;
  fill: #212529;
}

.filter-section.show .btn>svg,
.load-dropdown.show .btn .dots,
.load-dropdown-2.show .btn .dots,
.filter-section.active-dropdown .btn>svg,
.filter-section.show .btn>div>svg,
.filter-section.active-dropdown .btn>div>svg,
.filter-section.active-dropdown .btn>div>p,
.filter-section.show .btn>div>p {
  fill: #367BF6 !important;
  stroke: #367BF6 !important;
  color: #367BF6 !important;
}

.filter-section.active-dropdown .btn>svg,
.filter-section.active-dropdown .btn>div>svg,
.table-columns-dropdown.show .btn .dots,
.table-columns-dropdown.show .btn .dots>rect {
  stroke: #367BF6 !important;
}

.import-excel-modal {
  margin: 0 9px !important;
}

.username-input-field {
  width: 100% !important;
  height: 100% !important;
  border: none !important;
}

.input-group-text {
  background-color: white !important;
  font-size: 12px !important;
}

#modal-set-password .modal-md .modal-body {
  padding: 25px 25px 0px 25px !important;
}

@media (max-width: 575px) {

  .table-columns-section .btn.btn-table-columns-section,
  .table-columns-dropdown .btn.dropdown-toggle,
  .btn.btn-table-columns-section {
    width: 100% !important;
  }

  .btn-dashboard-export-table-btn {
    width: 44px !important;
  }
}
</style>
